import React from 'react';
import './Clients.css';

import { Heading } from '../../../components';
import { clients } from '../../../constants';

// Import Swiper core and required modules
import { Autoplay } from 'swiper';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';



const Clients = () => {

  return (
    <section className='clients'>

      {/* Section heading */}
      <Heading title={'our clients'} subTitle={'Valued Client Partners'} />

      <div className='client-slider'>

        <Swiper
          // Install Swiper modules
          modules={[Autoplay]}
          spaceBetween={20}
          loop={true}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          breakpoints={{
            0: {
              slidesPerView: 2,
            },
            450: {
              slidesPerView: 3,
            },
            768: {
              slidesPerView: 4,
            },
            1024: {
              slidesPerView: 5,
            },
          }} 
        >
        {/* Map over the clients array to render each sponsor */}
        {clients.map((client, index) => {
            return (
              /* Render the client image */
              <SwiperSlide className='client-item' key={index}><img src={client} alt='' /></SwiperSlide>
            )
          })
        }
        </Swiper>
      </div>
    </section>
  );
}

export default Clients;